export var createMediaQueryString = function(param) {
    var min = param.min, max = param.max;
    var minQuery = min ? "and (min-width: ".concat(min, ") ") : "";
    var maxQuery = max ? "and (max-width: ".concat(max, ") ") : "";
    return "@media screen ".concat(minQuery).concat(maxQuery);
};
export var MIN_WIDTH_BREAKPOINTS = {
    MOBILE: 0,
    TABLET: 768,
    DESKTOP: 1024,
    XLARGE: 1440,
    XXLARGE: 1920
};
var RESPONSIVE = {
    mobile: {
        max: "".concat(MIN_WIDTH_BREAKPOINTS.TABLET - 1, "px")
    },
    tablet: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.TABLET, "px"),
        max: "".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP - 1, "px")
    },
    desktop: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP, "px"),
        max: "".concat(MIN_WIDTH_BREAKPOINTS.XLARGE - 1, "px")
    },
    xlarge: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.XLARGE, "px"),
        max: "".concat(MIN_WIDTH_BREAKPOINTS.XXLARGE - 1, "px")
    },
    xxlarge: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.XXLARGE, "px")
    },
    tabletAndBelow: {
        max: "".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP - 1, "px")
    },
    tabletAndAbove: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.TABLET, "px")
    },
    desktopAndAbove: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP, "px")
    },
    xLargeAndAbove: {
        min: "".concat(MIN_WIDTH_BREAKPOINTS.XLARGE, "px")
    }
};
/** @deprecated use media2strings from theme instead */ export var media2strings = {
    mobile: createMediaQueryString(RESPONSIVE.mobile),
    tablet: createMediaQueryString(RESPONSIVE.tablet),
    desktop: createMediaQueryString(RESPONSIVE.desktop),
    xlarge: createMediaQueryString(RESPONSIVE.xlarge),
    xxlarge: createMediaQueryString(RESPONSIVE.xxlarge),
    tabletAndAbove: createMediaQueryString(RESPONSIVE.tabletAndAbove),
    tabletAndBelow: createMediaQueryString(RESPONSIVE.tabletAndBelow),
    desktopAndAbove: createMediaQueryString(RESPONSIVE.desktopAndAbove),
    xLargeAndAbove: createMediaQueryString(RESPONSIVE.xLargeAndAbove),
    canHover: "@media (hover: hover)"
};
